import { cn } from "@/lib/utils";

type MainSectionSectionProps = {
  children: React.ReactNode;
  fontFamily?: string;
  gap?: string;
};

const MainSectionSection = ({ children, fontFamily, gap }: MainSectionSectionProps) => {
  return (
    <div
      className={cn("flex flex-col gap-6 py-4 md:py-8 lg:py-12 px-4 md:px-6 lg:px-9")}
      style={{ fontFamily, gap }}
    >
      {children}
    </div>
  );
};

export default MainSectionSection;
